import { Paper, Typography } from '@mui/material';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { formatDate, formatMoney } from '../utils';

const RevenueChart = ({ data }) => (
  <Paper sx={{ p: 2.5, mb: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#0d3c61' }}>Revenue & Payments Over Time</Typography>
    <ResponsiveContainer width="100%" height={250}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" tickFormatter={formatDate} fontSize={11} />
        <YAxis tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} fontSize={11} />
        <Tooltip formatter={(v) => formatMoney(v)} labelFormatter={(v) => new Date(v).toLocaleDateString()} />
        <Legend />
        <Line type="monotone" dataKey="revenue" name="Contract Value" stroke="#1976d2" strokeWidth={2} dot={{ r: 4 }} activeDot={{ r: 6 }} />
        <Line type="monotone" dataKey="paid" name="Paid" stroke="#2e7d32" strokeWidth={2} strokeDasharray="5 5" dot={{ r: 4 }} activeDot={{ r: 6 }} />
      </LineChart>
    </ResponsiveContainer>
  </Paper>
);

export default RevenueChart;
